/**
 * Is the scheme-membership variant of the Membership screens enabled?
 *
 * MUST be called at render time, never cached in a module-level const.
 * `vendorData` is written to sessionStorage during login, and a module
 * evaluated before that write captures `false` forever — which is why the
 * panel showed "Membership" right after logging in and "Scheme Membership"
 * only after a hard reload (on reload, sessionStorage is already populated
 * before any module loads).
 */
export function isSchemeMembershipEnabled() {
  try {
    return (
      JSON.parse(sessionStorage.getItem("vendorData"))?.addon_features
        ?.scheme_membership === true
    );
  } catch {
    // Malformed vendorData shouldn't take the whole screen down.
    return false;
  }
}
